/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PalAuthIntegration } from './PalAuthIntegration';
import {
    PalAuthIntegrationFromJSON,
    PalAuthIntegrationFromJSONTyped,
    PalAuthIntegrationToJSON,
    PalAuthIntegrationToJSONTyped,
} from './PalAuthIntegration';

/**
 * 
 * @export
 * @interface FindAllPalAuthIntegrationsForLead200Response
 */
export interface FindAllPalAuthIntegrationsForLead200Response {
    /**
     * List of PAL auth integrations
     */
    data?: Array<PalAuthIntegration>;
}

/**
 * Check if a given object implements the FindAllPalAuthIntegrationsForLead200Response interface.
 */
export function instanceOfFindAllPalAuthIntegrationsForLead200Response(value: object): value is FindAllPalAuthIntegrationsForLead200Response {
    return true;
}

export function FindAllPalAuthIntegrationsForLead200ResponseFromJSON(json: any): FindAllPalAuthIntegrationsForLead200Response {
    return FindAllPalAuthIntegrationsForLead200ResponseFromJSONTyped(json, false);
}

export function FindAllPalAuthIntegrationsForLead200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllPalAuthIntegrationsForLead200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(PalAuthIntegrationFromJSON)),
    };
}

export function FindAllPalAuthIntegrationsForLead200ResponseToJSON(json: any): FindAllPalAuthIntegrationsForLead200Response {
    return FindAllPalAuthIntegrationsForLead200ResponseToJSONTyped(json, false);
}

export function FindAllPalAuthIntegrationsForLead200ResponseToJSONTyped(value?: FindAllPalAuthIntegrationsForLead200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(PalAuthIntegrationToJSON)),
    };
}

